import { useEffect, useMemo } from "react";
import { IItemProps } from "devextreme-react/form";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";

import { getUserProfileFromCache } from "../../services/userSettingService";

import { InactivatableCrudDataGrid } from "../common/InactivatableCrudDataGrid";

import { dummyJournalEntryExportSettingRow, journalEntryExportSettingColumns } from "./model/metaData";
import { JournalEntryExportSettingFields } from "./JournalEntryExportSettingFields";

const JournalEntryExportSettings = (pageProps: PageProps) => {
  const logger = pageProps.loggerProvider.getLogger("JournalEntryExportSettings");
  logger.debug("Rendering JournalEntryExportSettings page");

  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const editorItemOptions = useMemo(() => new Map<string, IItemProps>([
    [
      "active",
      {
        editorType: "dxCheckBox",
      },
    ],
  ]), []);

  const organizationId = getUserProfileFromCache(pageProps.dataStore).defaultOrganization;
  const detailComponent = (props: any) => {
    return (
      <JournalEntryExportSettingFields
        parentKey={{
          organizationId: organizationId,
          exportSettingName: props.data.data.exportSettingName,
        }}
        pageProps={pageProps}
        logger={logger}
      />
    );
  };

  return (
    <InactivatableCrudDataGrid
      pageProps={pageProps}
      logger={logger}
      dummyRow={dummyJournalEntryExportSettingRow}
      baseUrl="journal-entry-export-settings"
      isOrganizationData={true}
      keyExpr="exportSettingName"
      formTitle="Journal Entry Export Setting"
      formColCount={2}
      formColSpan={2}
      allowAdding={true}
      allowUpdating={true}
      allowDeleting={true}
      columnConfigs={journalEntryExportSettingColumns}
      masterDetailComponent={detailComponent}
      editorItemOptions={editorItemOptions}
    ></InactivatableCrudDataGrid>
  );
};

export default JournalEntryExportSettings;
